import React, { Component } from 'react';
import { FormSpy } from 'react-final-form';
import { FormError } from '../form';
import { modalOpen } from '../../actions/modals';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FORM_ERROR } from "final-form";
import map from "lodash/map";
import get from "lodash/get";
import isEqual from "lodash/isEqual";

import ModalLink from '../modals/ModalLink';


import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-regular-svg-icons/faSparkles';
import { currentCustomerSubscriptionPlanSelector } from '../../reducers/selectors';

const mapStateToProps = state => ({ currentCustomerSubscriptionPlan: currentCustomerSubscriptionPlanSelector(state) });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ modalOpen }, dispatch);
};


class AccountLimitsErrorComponent extends Component {
  
  constructor (props){
    super(props);
    
    this.state = {
      show: true
    }
  }
  
  componentWillReceiveProps (nextProps) {
    const { submitErrors, currentCustomerSubscriptionPlan } = nextProps
    
    if ((currentCustomerSubscriptionPlan || {}).id !== (this.props.currentCustomerSubscriptionPlan || {}).id)
      this.setState({show: false});
    else if (!isEqual(submitErrors, this.props.submitErrors) ){
      this.setState({show: true});
    }
    
    if ( submitErrors && submitErrors[`${FORM_ERROR}-details`] && submitErrors[`${FORM_ERROR}-details`].account){
      const errors = map(submitErrors[`${FORM_ERROR}-details`].account, 'error').join('|')
      
      if ( errors && errors.match(/_limit_reached/) ){
        // this.props.modalOpen('activate', {size: "lg"});
      }
    }
    
  }
  
  render() {
    const { submitErrors } = this.props;
    const { show } = this.state;
    const errors = map(get(submitErrors || {}, `${FORM_ERROR}-details.account`) || [], 'error').join('|');
    
    return (show && submitErrors && submitErrors.account && <FormError>
      {submitErrors.account}
      {errors && errors.match(/_limit_reached/) &&
        <ModalLink to="activate" color="success" size="sm" params={{size: "lg"}} style={{marginLeft: '1.5em'}}><FA icon={faSparkles} /> Upgrade</ModalLink>
      }
    </FormError>) || null
  }
}
const AccountLimitsError = (props) => (
  <FormSpy
    {...props}
    subscription={{ submitErrors: true }}
    component={AccountLimitsErrorComponent}
  />
)

export default connect(mapStateToProps, matchDispatchToProps)(AccountLimitsError);


// WEBPACK FOOTER //
// ./src/components/billing/AccountLimitsError.js